module.exports = __webpack_public_path__ + "static/media/so-algo--dog1.04f08866.jpg";